"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ErrorResponse = _interopRequireDefault(require("../model/ErrorResponse"));
var _Language = _interopRequireDefault(require("../model/Language"));
var _RegisterFcmTokenParams = _interopRequireDefault(require("../model/RegisterFcmTokenParams"));
var _UnregisterFcmTokenParams = _interopRequireDefault(require("../model/UnregisterFcmTokenParams"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Manage My Pain API
 * This document provide full documentation for [ManagingLife](http://managinglife.com) API # Introduction Each API call only supports POST calls, and all parameters goes to body of POST request<br> Format of each API endpoint is `https://SERVER.managinglife.com/api/vVERSION/SERVICE/METHOD`   - **SERVER** could be one of: *dev*, *preprod*, *sync*.   - **VERSION** could be one of: *1*, *3*, *4*.   - **SERVICE** e.g. *core*, *sync*, *alerts*.   - **METHOD** e.g. *generate-report*, *login-user*, *update-records*.  Any parameter that is not marked as required can be null or omitted. # Client libraries We also provide several client libraries which were auto-generated using swagger-codegen.   - [JavaScript](/codegen/javascript)   - [Java](/codegen/java)   - [PHP](/codegen/php)   - [Objective C](/codegen/objc) # Authentication <!-- ReDoc-Inject: <security-definitions> --> 
 *
 * The version of the OpenAPI document: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Notifications service.
* @module api/NotificationsApi
* @version 4.0.0
*/
var NotificationsApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new NotificationsApi. 
  * @alias module:api/NotificationsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function NotificationsApi(apiClient) {
    _classCallCheck(this, NotificationsApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * register-anonymous-fcm-token
   * Register new Firebase Cloud Messaging token or update expiration time for existing FCM token specific for each unauthorized users device. It is used for sending notifications to user. This token should be generated by frontend Firebase SDK. For automated tests it can accept `test` instead of valid token when API test mode enabled.
   * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
   * @param {module:model/RegisterFcmTokenParams} params 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */
  return _createClass(NotificationsApi, [{
    key: "notificationsRegisterAnonymousFcmTokenPostWithHttpInfo",
    value: function notificationsRegisterAnonymousFcmTokenPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling notificationsRegisterAnonymousFcmTokenPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling notificationsRegisterAnonymousFcmTokenPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/notifications/register-anonymous-fcm-token', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * register-anonymous-fcm-token
     * Register new Firebase Cloud Messaging token or update expiration time for existing FCM token specific for each unauthorized users device. It is used for sending notifications to user. This token should be generated by frontend Firebase SDK. For automated tests it can accept `test` instead of valid token when API test mode enabled.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/RegisterFcmTokenParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
  }, {
    key: "notificationsRegisterAnonymousFcmTokenPost",
    value: function notificationsRegisterAnonymousFcmTokenPost(Accept_Language, params) {
      return this.notificationsRegisterAnonymousFcmTokenPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * register-fcm-token
     * Register new Firebase Cloud Messaging token or update expiration time for existing FCM token specific for each users device. It is used for sending notifications to users. This token should be generated by frontend Firebase SDK. For automated tests it can accept `test` instead of valid token when API test mode enabled.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/RegisterFcmTokenParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
  }, {
    key: "notificationsRegisterFcmTokenPostWithHttpInfo",
    value: function notificationsRegisterFcmTokenPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling notificationsRegisterFcmTokenPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling notificationsRegisterFcmTokenPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/notifications/register-fcm-token', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * register-fcm-token
     * Register new Firebase Cloud Messaging token or update expiration time for existing FCM token specific for each users device. It is used for sending notifications to users. This token should be generated by frontend Firebase SDK. For automated tests it can accept `test` instead of valid token when API test mode enabled.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/RegisterFcmTokenParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
  }, {
    key: "notificationsRegisterFcmTokenPost",
    value: function notificationsRegisterFcmTokenPost(Accept_Language, params) {
      return this.notificationsRegisterFcmTokenPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * unregister-fcm-token
     * Remove provided FCM token from database. This token should be generated by frontend Firebase SDK. For automated tests it can accept `test` instead of valid token when API test mode enabled.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/UnregisterFcmTokenParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
  }, {
    key: "notificationsUnregisterFcmTokenPostWithHttpInfo",
    value: function notificationsUnregisterFcmTokenPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling notificationsUnregisterFcmTokenPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling notificationsUnregisterFcmTokenPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/notifications/unregister-fcm-token', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * unregister-fcm-token
     * Remove provided FCM token from database. This token should be generated by frontend Firebase SDK. For automated tests it can accept `test` instead of valid token when API test mode enabled.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/UnregisterFcmTokenParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
  }, {
    key: "notificationsUnregisterFcmTokenPost",
    value: function notificationsUnregisterFcmTokenPost(Accept_Language, params) {
      return this.notificationsUnregisterFcmTokenPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();